import React, { useEffect } from "react";
import { useRoute } from "./lib/router.js";
import PaymentService from "./pages/PaymentService.jsx";
import Bespoke from "./pages/Bespoke.jsx";
import Php2Shell from "./pages/Php2Shell.jsx";
import LegalNotice from "./pages/LegalNotice.jsx";
import PrivacyNotice from "./pages/PrivacyNotice.jsx";

const BUILD_IDENTIFIER = process.env.ASKMAX_BUILD_IDENTIFIER || "";

export default function App() {
  const { path, state, go } = useRoute();
  useEffect(() => {
    if (path === "/ask" || path === "/about-max" || path === "/model-lab") {
      window.history.replaceState(window.history.state, "", "/");
    }
  }, [path]);

  const page = path === "/privacy" || path === "/privacy/"
    ? <PrivacyNotice onNavigate={go} />
    : path === "/legal-notice"
      ? <LegalNotice onNavigate={go} />
      : path === "/check-a-payment"
        ? <PaymentService onNavigate={go} />
        : path === "/php2shell"
          ? <Php2Shell onNavigate={go} />
          : <Bespoke onNavigate={go} initialEnquiry={state?.enquiry} initialSection={state?.section} />;

  return (
    <>
      {page}
      {BUILD_IDENTIFIER && (
        <div className="build-identifier" aria-label="Build identifier">
          {BUILD_IDENTIFIER}
        </div>
      )}
    </>
  );
}
